import { render, staticRenderFns } from "./OilSampleDetails.vue?vue&type=template&id=8106afd4"
import script from "./OilSampleDetails.vue?vue&type=script&lang=js"
export * from "./OilSampleDetails.vue?vue&type=script&lang=js"
import style0 from "./OilSampleDetails.vue?vue&type=style&index=0&id=8106afd4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports